export interface HotEvent {
  id: number;
  tag: string;
  title: string;
  summary: string;
  heat: string;
  time: string;
  comments: number;
  reads: number;
}

export const hotEvents: HotEvent[] = [
  {
    id: 1,
    tag: "娱乐",
    title: "新综艺阵容官宣后热搜不断，网友扒出的路透细节比正片还精彩",
    summary: "阵容刚公布半天，站子图、行程表、节目规则疑似全被挖出，讨论楼盖到上千层，有人喊话节目组赶紧锁死名单。",
    heat: "爆",
    time: "2 分钟前",
    comments: 2384,
    reads: 128600,
  },
  {
    id: 2,
    tag: "互联网",
    title: "某大厂内测新社交产品被截图流出，评论区吵翻了：是创新还是蹭热度",
    summary: "内部灰度测试的页面截图在群里疯传，产品形态引发两派争论，关于“还差一个功能就能出圈”的段子层出不穷。",
    heat: "热",
    time: "18 分钟前",
    comments: 1562,
    reads: 96100,
  },
  {
    id: 3,
    tag: "社会",
    title: "一场被刷屏的跨城寻人事件，三天后当事人回应，真相和想象的不太一样",
    summary: "从全网接力转发到当事人发声，整个过程反转又反转。热心网友复盘了整条时间线，发现关键线索其实早就埋下。",
    heat: "爆",
    time: "45 分钟前",
    comments: 4021,
    reads: 210300,
  },
  {
    id: 4,
    tag: "饭圈",
    title: "颁奖礼票数相差不足百票，两边工作室先后下场，站姐连夜冲业绩",
    summary: "倒数两小时票数咬得极紧，超话、粉丝群全动员，数据组晒出每分钟增幅曲线，最终结果差得让人心跳骤停。",
    heat: "热",
    time: "1 小时前",
    comments: 1890,
    reads: 87500,
  },
  {
    id: 5,
    tag: "数码",
    title: "旗舰机首销半天缺货，黄牛加价千元，抢到的人已经开始测评",
    summary: "线上开售十几分钟售罄，二手平台立刻挂出加价链接。首批到手用户陆续放出上手视频，评价两极分化明显。",
    heat: "新",
    time: "2 小时前",
    comments: 998,
    reads: 64200,
  },
  {
    id: 6,
    tag: "职场",
    title: "年终奖与绩效挂钩的消息刚传开，几个大厂的员工群已经悄悄改名",
    summary: "消息一出，职场社交平台上相关帖子阅读量直线上升，有人晒出聊天记录吐槽，也有人搬出往年数据开始“预言”。",
    heat: "温",
    time: "3 小时前",
    comments: 734,
    reads: 50300,
  },
];

export const channelItems = [
  { name: "娱乐八卦", icon: "ri-flashlight-line", desc: "剧集、综艺与明星热点", count: 1280 },
  { name: "互联网圈", icon: "ri-global-line", desc: "大厂动态与产品观察", count: 934 },
  { name: "社会热议", icon: "ri-discuss-line", desc: "身边事与全网焦点", count: 1612 },
  { name: "饭圈观察", icon: "ri-heart-3-line", desc: "打投、站姐与饭圈文化", count: 806 },
  { name: "数码前沿", icon: "ri-smartphone-line", desc: "新品首发与硬核评测", count: 511 },
  { name: "职场瓜田", icon: "ri-briefcase-4-line", desc: "打工人日常与职场热议", count: 647 },
];

export interface Roundup {
  id: number;
  title: string;
  tag: string;
  excerpt: string;
  image: string;
  likes: number;
  time: string;
}

export const roundups: Roundup[] = [
  {
    id: 1,
    tag: "大瓜合集",
    title: "一周互联网大瓜合集：那些没追完的后续都在这里",
    excerpt: "把本周全网吵翻天的几件大事完整梳理了一遍，附上时间线与各方说法，吃瓜不迷路。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20newsroom%20collage%20of%20glowing%20smartphone%20screens%20and%20magazine%20headlines%20scattered%20on%20warm%20cream%20desk%2C%20warm%20coral%20and%20green%20accents%2C%20editorial%20photography%2C%20soft%20studio%20light%2C%20vibrant%20yet%20cohesive&width=800&height=600&seq=chigua-round-1&orientation=portrait",
    likes: 982,
    time: "今日更新",
  },
  {
    id: 2,
    tag: "时间线复盘",
    title: "一瓜吃到底：从首曝到回应，三天完整时间线复盘",
    excerpt: "事件从深夜一条动态开始发酵，我们整理了每一条关键发言与转折点，帮你把来龙去脉看得清清楚楚。",
    image: "https://readdy.ai/api/search-image?query=minimalist%20timeline%20infographic%20with%20numbered%20dots%20and%20paper%20notes%20on%20warm%20beige%20background%2C%20coral%20highlights%2C%20modern%20editorial%20flat%20lay%2C%20clean%20and%20stylish&width=800&height=600&seq=chigua-round-2&orientation=portrait",
    likes: 640,
    time: "昨日发布",
  },
  {
    id: 3,
    tag: "群聊流出",
    title: "截图真假难辨？教你三招快速分辨聊天记录是否拼接",
    excerpt: "吃瓜最怕吃到假瓜。从像素、字体到时间戳，几个小细节就能帮你判断这张截图靠不靠谱。",
    image: "https://readdy.ai/api/search-image?query=close%20up%20of%20chat%20message%20bubbles%20on%20phone%20screen%20against%20soft%20warm%20green%20backdrop%2C%20fresh%20minimal%20flat%20design%2C%20stylish%20illustration%20style%2C%20friendly%20and%20playful&width=800&height=600&seq=chigua-round-3&orientation=portrait",
    likes: 512,
    time: "2 天前",
  },
  {
    id: 4,
    tag: "合集精选",
    title: "本周讨论度最高的十个话题，看看有没有你错过的",
    excerpt: "覆盖娱乐、科技与社会多个圈层，每个话题都附带了讨论热度与围观入口，点进来一起补课。",
    image: "https://readdy.ai/api/search-image?query=colorful%20stack%20of%20trending%20topic%20chips%20and%20badges%20arranged%20playfully%20on%20cream%20background%2C%20watermelon%20coral%20and%20leaf%20green%20palette%2C%20modern%20editorial%20style&width=800&height=600&seq=chigua-round-4&orientation=portrait",
    likes: 410,
    time: "3 天前",
  },
];

export interface ForumPost {
  id: number;
  group: string;
  title: string;
  author: string;
  avatarText: string;
  avatarColor: string;
  replies: number;
  likes: number;
  time: string;
  hot?: boolean;
}

export const forumPosts: ForumPost[] = [
  {
    id: 1,
    group: "娱乐八卦组",
    title: "那个反转又反转的瓜，有没有人理一下到底谁说的对",
    author: "吃瓜不吐籽",
    avatarText: "籽",
    avatarColor: "bg-primary-500",
    replies: 326,
    likes: 1200,
    time: "半小时前",
    hot: true,
  },
  {
    id: 2,
    group: "社会热议组",
    title: "理性讨论：遇到全网刷屏的求助帖，普通人该怎么帮又不添乱",
    author: "观察员小王",
    avatarText: "察",
    avatarColor: "bg-accent-500",
    replies: 189,
    likes: 860,
    time: "1 小时前",
    hot: true,
  },
  {
    id: 3,
    group: "互联网圈组",
    title: "新 App 上线三天就登顶，是真有本事还是营销厉害",
    author: "码农阿强",
    avatarText: "码",
    avatarColor: "bg-secondary-500",
    replies: 142,
    likes: 655,
    time: "2 小时前",
  },
  {
    id: 4,
    group: "职场瓜田组",
    title: "同事把聊天记录发错群了，场面一度尴尬到想遁地",
    author: "社死星人",
    avatarText: "死",
    avatarColor: "bg-primary-400",
    replies: 231,
    likes: 990,
    time: "3 小时前",
    hot: true,
  },
  {
    id: 5,
    group: "数码前沿组",
    title: "首发机到手一周了，说说那些评测没提的细节",
    author: "数码老饕",
    avatarText: "数",
    avatarColor: "bg-accent-600",
    replies: 87,
    likes: 432,
    time: "5 小时前",
  },
  {
    id: 6,
    group: "饭圈观察组",
    title: "理性看打投：票池、规则与所谓的“黑幕”到底是怎么回事",
    author: "透明看客",
    avatarText: "客",
    avatarColor: "bg-secondary-400",
    replies: 76,
    likes: 388,
    time: "6 小时前",
  },
];

export const rankItems = [
  { rank: 1, title: "新综艺阵容路透不断，正片还没播热度先爆", delta: 3, comments: 2384 },
  { rank: 2, title: "跨城寻人三天反转，时间线复盘帖正在疯转", delta: 1, comments: 4021 },
  { rank: 3, title: "大厂新社交产品截图流出，内部员工已开始吐槽", delta: -1, comments: 1562 },
  { rank: 4, title: "颁奖礼票数咬紧，站姐连夜冲刺数据", delta: 2, comments: 1890 },
  { rank: 5, title: "旗舰机首销即缺货，黄牛加价千元仍有人买", delta: 0, comments: 998 },
  { rank: 6, title: "年度最佳剧集出炉，网友为落选方鸣不平", delta: 4, comments: 1206 },
];

export const faqs = [
  {
    q: "吃瓜聚集地是一个什么样的社区？",
    a: "吃瓜聚集地是一个面向全网热点与圈层话题的讨论社区。我们把娱乐、互联网、社会、数码等多个圈层的最新事件聚集到一处，让你用一套关注列表就能跟进全网焦点，也能在群组里和各路网友理性交流观点。",
  },
  {
    q: "如何快速找到我感兴趣的话题？",
    a: "首页顶部提供实时热点与热门搜索词，你可以先浏览“今日焦点”了解全网动态，再通过左侧的频道分类进入对应圈子。所有栏目都支持按热度排序，帮你第一时间锁定正在发酵的瓜。",
  },
  {
    q: "看到的内容都可靠吗，会不会吃到假瓜？",
    a: "我们鼓励内容标注来源与时间线，并对高风险消息做提示。同时也倡导网友理性围观、不传谣不造谣，任何事件都应以官方或当事人公开说法为准。遇到存疑内容，可以在群组内发起讨论互相印证。",
  },
  {
    q: "我可以加入群组参与讨论吗？",
    a: "可以。注册并完善资料后即可申请加入你感兴趣的群组，参与发言、点赞与互动。入群前请阅读并遵守社区规范，友善交流、尊重他人，共同维护良好的讨论氛围。",
  },
  {
    q: "如何订阅每天的热点汇总？",
    a: "在页面底部填写邮箱并订阅“吃瓜日报”，我们会每天为你整理当日讨论度最高的若干话题并发送到邮箱，让你不错过任何重点事件。订阅完全免费，随时可以退订。",
  },
];